// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Drawer, Menu, MenuItem, Submenu, MenuItemGroup, Form, FormItem, Button, Input, Select,
  Option, Radio, RadioGroup, Upload, Row, Col,
  Message,Dialog,
} from 'element-ui'
Vue.use(Drawer)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Upload)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dialog)

Vue.prototype.$message = Message;

// // 手势操作
var VueTouch = require('vue-touch')
Vue.use(VueTouch, { name: 'v-touch' })
VueTouch.config.swipe = {
  threshold: 60, //手指左右滑动距离
  direction: 'horizontal',
}
import '@/assets/rewrite.css' // global css
import '@/assets/font.css'


import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  window.scrollTo(0,0)
  // chrome
  // document.body.scrollTop = 0
  // // firefox
  // document.documentElement.scrollTop = 0
  // // safari
  // window.pageYOffset = 0
  next()
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js